import { render, staticRenderFns } from "./transferPartnerGoods.vue?vue&type=template&id=b003f010&scoped=true"
import script from "./transferPartnerGoods.vue?vue&type=script&lang=js"
export * from "./transferPartnerGoods.vue?vue&type=script&lang=js"
import style0 from "./transferPartnerGoods.vue?vue&type=style&index=0&id=b003f010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003f010",
  null
  
)

export default component.exports